import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_INFERNO } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/hollah.onsets.json' with { type: 'json' };
import normalImported from './imported/hollah-normal.circles.json' with { type: 'json' };
import hardImported from './imported/hollah-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/hollah-extreme.circles.json' with { type: 'json' };

export const HOLLAH_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'hollah',
  baseTitle: "Hollah!",
  description: "Disfigure's bouncy 140 BPM drumstep. Tight syncopation, hard-tier challenge.",
  difficulty: 4,
  palette: PALETTE_INFERNO,
  audioSrc: '/audio/circles/hollah.mp3',
  attribution: "\"Hollah!\" by Disfigure [NCS Release] - https://ncs.io/Hollah",
  mapper: "xChorse",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    hard: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    extreme: { bpm: 145, offsetMs: 0, totalBeats: 148 },
  },
});
